'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';

/** Props */
interface LoginNavTabsProps {
  activeTab?: 'login' | 'register';
  type?: 'default' | 'recruiter';
}

/** Classes */
const classes = {
  common: 'py-4 border-t-3 border-b border-l border-l-ink/10 font-semibold text-sm first:border-l-0',
  active: 'bg-surface text-primary border-b-transparent border-t-secondary',
  inactive: 'bg-secondary/10 border-surface border-b-ink/10 border-t-transparent',
};

/**
 * @description Login navigation tabs component.
 * - `activeTab`: The active tab. It can be either `login` or `register`.
 */
export const AuthNavTabs = (props: LoginNavTabsProps) => {
  // Destructure props
  const {
    activeTab = '',
    type = 'default',
  } = props;

  // Get the translation
  const { t } = useTranslation('common');

  // Render component
  // *************************
  return (
    <div className="relative grid grid-cols-2 rounded-t-md">
      <LinkStyled
        styling="none"
        href={type === 'recruiter' ? '/login/recruiter' : '/login'}
        className={`${classes.common} ${activeTab === 'login' ? classes.active : classes.inactive} rounded-tl-md`}
      >
        {t('sign_in.button')}
      </LinkStyled>

      <LinkStyled
        styling="none"
        href={type === 'recruiter' ? '/register/recruiter' : '/register'}
        className={`${classes.common} ${activeTab === 'register' ? classes.active : classes.inactive} rounded-tr-md`}
      >
        {t('sign_in.register')}
      </LinkStyled>
    </div>
  );
};
